export default "__VITE_ASSET__BshP0tAr__"